import { boot } from '@dazn/bootstrap-lib';

export const getGeoZones = (
    geo: boot.user.UserToken['geo'] | undefined,
): string => {
    const zones = Object.values(geo ?? {}).flatMap(region => region?.z ?? []);

    return [...new Set(zones)].join(',');
};
